import { CredentialItem } from './credential-item'

export class BackgroundScreenCredentialItem extends CredentialItem {

  private readonly labelMap = {
    cancelled: 'Canceled',
    closed : 'Closed',
    expired : 'Expired',
    failed : 'Failed',
    flagged : 'Flagged',
    incomplete : 'Incomplete',
    passed : 'Passed',
    pending_verification : 'Pending Verification',
    pending : 'Pending',
    required : 'Required'
  }

  private readonly colorMap = {
    required: 'gray',
    flagged: 'red',
    pending: 'yellow',
    pending_verification: 'yellow',
    passed: 'green',
    cancelled: 'red',
    closed: 'red',
    failed: 'red',
    incomplete: 'red',
    expired: 'red'
  }

  public constructor(data: any) {
    super(data)

    let status = this.credential.eligibility_status
    if (status === 'flagged') status = 'pending'

    const color = this.colorMap[status]
    const value = this.labelMap[status]
    this.setStatusTag({ color, value })

    if (status === 'expired') {
      this.validityLabel = `Expired ${this.getDate(this.credential.expires_at)}`
    }
    if (status === 'passed') {
      this.validityLabel = `Valid from ${this.getDate(this.credential.effective_at)} - ${this.getDate(this.credential.expires_at)}`
    }
  }

}
